const CourseSetting = {
    SLIGHT_TURNING: 'SLIGHT_TURNING',
    TURNING: 'TURNING',
    SLIGHT_TURNING_STRAIGHT: 'SLIGHT_TURNING_STRAIGHT',
    STRAIGHT: 'STRAIGHT'
}

export default CourseSetting;
